<div class="container">
  <div class="row d-flex align-items-center">
    <div class="d-flex align-items-center col-auto">
      <button class="nav-back" routerLink="/projects">
        <fa-icon [icon]="faChevronLeft" size="lg"></fa-icon>
      </button>
      <h1 class="title ms-2">{{titleValue}}</h1>
    </div>
    <div class="col-md-7 text-right">
      <span *ngIf="false" class="mr-2" style="font-weight: bold; font-size: 1.2em;">{{ timerService.timer$ | async
        }}</span>
      <a [routerLink]="['/project', projectId]" class="mb-0" style="font-size: 27px;">
        <fa-icon id="iconExecLink" class="mx-2" title="Project Summary" [icon]="iconExecutionLink" size="md"></fa-icon>
      </a>
    </div>
  </div>

  <!-- <div class="col-md-7 text-right">
    <a [routerLink]="['/project', projectId]" class="mb-0" style="font-size: 27px;">
       <fa-icon id="iconExecLink" class="mx-2"
          title="Project Summary" [icon]="iconExecutionLink" size="md"></fa-icon>
    </a>
  </div> -->
</div>


<div id="new-project-form" class="md-form card container">
  <form #projectForm="ngForm" (ngSubmit)="saveProject(projectForm.value)" class="card-body" name="projectForm"
    novalidate>
    <div class="row">
      <div class="col-12 col-sm-5">
        <div class="form-group">
          <select [formControl]="clientControl" [compareWith]="clientCompareFn" id="client-filter" name="clientControl"
            (change)="clientChanged()" class="form-control form-control-sm">
            <option [ngValue]="0" selected>Clients</option>
            <option *ngFor="let client of clientList" [attr.selected]="selectedClient" [ngValue]="client">
              {{ client.Name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <select [formControl]="assetControl" [compareWith]="assetCompareFn" id="asset-filter" name="assetControl"
            class="form-control form-control-sm">
            <option [ngValue]="0" selected>Assets</option>
            <option *ngFor="let asset of assetList" [ngValue]="asset">
              {{ asset.Name }}
            </option>
          </select>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label for="project-name">Project Name</label>
          <input [(ngModel)]="project.ProPakProject.Name" name="projectName" type="text" id="project-name"
            placeholder="" />
        </div>

        <!--<div class="form-group">
            <label for="team-member-id">Team Member ID</label>
            <input [(ngModel)]="project.teamMemberId" type="text" id="team-member-id" placeholder="" />
          </div>-->

        <div class="form-group">
          <label for="primavera-id">Primavera Project Identifier</label>
          <input [(ngModel)]="primaveraId" name="primaveraId" type="text" id="primavera-id" placeholder="" />
        </div>

        <div class="row">
          <div class="col-6 col-sm-6">
            <div class="form-group">
              <label for="chart-type">Display Chart Type</label>
              <div class="d-flex align-items-center">
                <select [(ngModel)]="project.ProjectDisplayType" name="chartType" id="chart-type"
                  class="form-control form-control-sm narrow-dropdown">
                  <option value="horizontalBar,scurve">Both</option>
                  <option value="horizontalBar">Horizontal Bars</option>
                  <option value="scurve">S-Curve</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6 col-sm-6">
            <div class="form-group">
              <label for="chart-type">Activities Display</label>
              <div class="d-flex align-items-center">
                <select [(ngModel)]="project.ActivitiesDisplayType" name="activitiesType" id="activities-type"
                  class="form-control form-control-sm narrow-dropdown">
                  <option value="unitPercentComplete,durationPercentComplete">Both</option>
                  <option value="unitPercentComplete">Unit % Complete</option>
                  <option value="durationPercentComplete">Duration % Complete</option>
                </select>
              </div>
            </div>

          </div>
        </div>
        <div class="form-group d-flex align-items-center" style="gap: 2rem;">
          <label style="white-space: nowrap; display: flex; align-items: center; margin: 0;">
            <input type="checkbox" [(ngModel)]="project.ShowProjected" name="ShowProjected" style="margin-right: 5px;">
            Show Projected
          </label>
          <label style="white-space: nowrap; display: flex; align-items: center; margin: 0;">
            <input type="checkbox" [(ngModel)]="project.ShowFullSchedule" name="ShowFullSchedule"
              style="margin-right: 5px;">
            Show Full Schedule
          </label>
        </div>

        <div class="form-group">
          <label for="readiness-sheet-unc">Readiness Assessment Location</label>
          <input [(ngModel)]="project.ReadinessAssessmentPath" name="readinessAssessmentPath" type="text"
            id="readiness-sheet-unc" placeholder="" />
        </div>

        <div class="form-group">
          <label for="readiness-sheet-unc">Power BI Report</label>
          <input [(ngModel)]="project.PowerBiReportPath" name="powerBiReportPath" type="text" id="powerBi-sheet-unc"
            placeholder="" />
        </div>

        <div class="form-group">
          <label for="readiness-sheet-unc">Project Folder</label>
          <input [(ngModel)]="project.MasterReport" name="masterReport" type="text" id="readiness-sheet-unc"
            placeholder="" />
        </div>
      </div>

      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label for="client-id-list">Client Job Identifiers</label>
          <mat-form-field class="client-id-chip-list col no-gutters">
            <input placeholder="" id="client-id-list" [matChipInputFor]="ClientJobIds"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="addClient($event)">

            <mat-chip-grid #ClientJobIds>
              <mat-chip-row *ngFor="let client of clientIds" [selectable]="selectable" [removable]="removable"
                (removed)="removeClient(client)">
                {{client}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip-row>
            </mat-chip-grid>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="site-sense-id-list">SiteSense Project Name</label>
          <mat-form-field class="site-sense-chip-list col no-gutters">
            <input placeholder="" id="site-sense-id-list" [matChipInputFor]="SiteSenseProjectName"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="addSiteSense($event)">

            <mat-chip-grid #SiteSenseProjectName>
              <mat-chip-row *ngFor="let id of siteSenseIds" [selectable]="selectable" [removable]="removable"
                (removed)="removeSiteSense(id)">
                {{id}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip-row>
            </mat-chip-grid>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="site-sense-id-list">CX Planner Project Name</label>
          <mat-form-field class="site-sense-chip-list col no-gutters">
            <input placeholder="" id="cx-planner-id-list" [matChipInputFor]="CXPlannerIdentifiers"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="addCXPlanner($event)">

            <mat-chip-grid #CXPlannerIdentifiers>
              <mat-chip-row *ngFor="let id of cxPlannerIds" [selectable]="selectable" [removable]="removable"
                (removed)="removeCXPlanner(id)">
                {{id}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip-row>
            </mat-chip-grid>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-end  align-items-center form-buttons">
      <div class="clickable" (click)="cancel()">Cancel</div>
      <button [disabled]="!formValid()">{{buttonValue}}</button>
    </div>

  </form>
</div>